var map = {
	"./icons_avalanche.svg": 69,
	"./icons_avalanche_blue.svg": 21,
	"./icons_hintarrow.svg": 70,
	"./icons_landslide.svg": 71,
	"./icons_landslide_blue.svg": 22,
	"./icons_minus.svg": 72,
	"./icons_pattern.svg": 73,
	"./icons_pattern_2.svg": 74,
	"./icons_pattern_2_big.svg": 75,
	"./icons_pattern_big.svg": 76,
	"./icons_pattern_key_full.svg": 77,
	"./icons_pattern_key_none.svg": 78,
	"./icons_pattern_key_part.svg": 79,
	"./icons_plus.svg": 80,
	"./icons_rockfall.svg": 81,
	"./icons_rockfall_blue.svg": 23,
	"./icons_water.svg": 82,
	"./icons_water_blue.svg": 24
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;